import React from "react";

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";

import logoNoText from '../../../../assets/img/ls_logo_print.png';

const DatumLogo = () => {
    const renderTooltip = (messageTooltip: String) => {
        return (
            <Tooltip id="button-tooltip">
                {messageTooltip}
            </Tooltip>
        );
    }

    return (
        <div className="d-flex justify-content-around nav navbar-logo-parent">
            <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Back to dashboard list")}>
                <Link to="/">
                    <img
                        src={logoNoText}
                        height="32px"
                        className="d-inline-block align-middle logo-padding"
                        alt={"Datum Geospatial"}
                    />
                </Link>
            </OverlayTrigger>
        </div>
    );
}

export default DatumLogo;